import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import axios from "axios";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CircularProgress from "@mui/material/CircularProgress";
import "./CoursePage.css";
import BASE_URL from "../../../config/api";
import { AppContext } from "../../../context/AppContext";
import course_image from "../../../images/stikeri export 5.png";
import SectionsTable from "../../../components/UserDashboard/SectionsTable/SectionsTable";

const CoursePage = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const { token } = useContext(AppContext);

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/courses/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = response.data;
        setCourse(data);
        setLoading(false);
        
      } catch (error) {
        
        setLoading(false);
      }
    };

    if (token) {
      fetchCourseDetails();
    }
  }, [id, token]);

  if (loading) {
    return (
      <div className="loading-spinner">
        <CircularProgress />
      </div>
    );
  }

  if (!course) {
    return <div className="title">You are not enrolled in this course.</div>;
  }

  return (
    <div className="course-page-container">
      <div className="course-details">
        <img
          alt="course"
          src={course_image}
          className="course-image-left"
        ></img>
        <div className="left-part-course">
          <p className="title-course-details">About course {course.title}</p>
          <p className="course-details-wrapper" style={{ fontWeight: "600" }}>
            <MenuBookIcon /> {course.sections.length} chapters
          </p>
          <p className="course-details-wrapper" style={{ fontWeight: "600" }}>
            <SignalCellularAltIcon /> Level: {course.rating}
          </p>
        </div>
      </div>
      {course.sections && course.sections.length > 0 ? (
        <SectionsTable sections={course.sections} />
      ) : (
        <p>No sections available for this course</p>
      )}
    </div>
  );
};

export default CoursePage;
